export class NotAuthorizedError extends Error {
  public readonly code: string

  constructor(message: string = "Not authorized. Login first, please.", code: string = "NOT_AUTHORIZED") {
    super(message)
    this.name = "NotAuthorizedError"
    this.code = code

    Object.setPrototypeOf(this, new.target.prototype)
  }

  public getFormattedMessage(): string {
    return `[${this.code}] ${this.message}`
  }
}
